import React, { useState } from "react";
import { Pressable, View } from "react-native";
import tw from "twrnc";
import { Ionicons } from "@expo/vector-icons";
import Text from "@/components/shared/AppText";
import {
  t,
  getLanguagePreference,
  languageName,
  languageOptions,
  setLanguagePreference,
} from "@/localization";

// Profile › Language: Automatic (the device's or browser's language), then
// each language the app speaks, in its own name. Choosing one reloads the app
// in it.
const LanguagePicker = ({ disabled = false }) => {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const current = getLanguagePreference();

  const choose = async (value) => {
    setOpen(false);
    if (value === current) return;
    setSaving(true);
    try {
      await setLanguagePreference(value);
    } finally {
      setSaving(false);
    }
  };

  return (
    <View>
      <Pressable
        onPress={() => setOpen(!open)}
        disabled={disabled || saving}
        accessibilityRole="button"
        accessibilityState={{ expanded: open }}
        style={tw`w-full py-4 px-4 border-b border-gray-200 active:bg-gray-50 flex-row items-center ${
          disabled || saving ? "opacity-50" : ""
        }`}
      >
        <Ionicons
          name="language-outline"
          size={22}
          color="#3F5B7A"
          style={tw`mr-3`}
        />
        <Text style={tw`text-base flex-1`}>{t("Language")}</Text>
        <Text style={tw`text-base text-gray-500 mr-2`} numberOfLines={1}>
          {languageName(current)}
        </Text>
        <Ionicons
          name={open ? "chevron-up" : "chevron-down"}
          size={20}
          color="#AEAEB2"
        />
      </Pressable>
      {open &&
        languageOptions().map((option) => (
          <Pressable
            key={option.value}
            onPress={() => choose(option.value)}
            accessibilityRole="radio"
            accessibilityState={{ checked: option.value === current }}
            style={tw`w-full py-3 pl-14 pr-4 border-b border-gray-100 bg-gray-50 active:bg-gray-100 flex-row items-center`}
          >
            <Text style={tw`text-base flex-1`}>{option.label}</Text>
            {option.value === current && (
              <Ionicons name="checkmark" size={20} color="#3F5B7A" />
            )}
          </Pressable>
        ))}
    </View>
  );
};

export default LanguagePicker;
